/* Won't Miss Garage media v0.1.0
   Plays product videos on their own, no hover needed. Uses IntersectionObserver so only on-screen videos
   consume bandwidth (configurable). GIFs need nothing: they are served as the original file. */
(function () {
  'use strict';
  var WMG = window.WMG = window.WMG || {};
  var cfg = (WMG.config && WMG.config.media) || {};
  var enabled = cfg.autoplay !== false;
  var onlyVisible = cfg.onlyVisible !== false;

  function play(v) {
    if (!enabled) return;
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute('muted', '');
    v.playsInline = true;
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }
  function pause(v) { try { v.pause(); } catch (e) {} }

  var io = null;
  if (enabled && onlyVisible && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) play(en.target); else pause(en.target);
      });
    }, { rootMargin: '160px 0px' });
  }

  function bind(root) {
    var vids = Array.prototype.slice.call((root || document).querySelectorAll('video[data-wmg-autoplay]'));
    vids.forEach(function (v) {
      if (v.__wmgBound) return;
      v.__wmgBound = true;
      v.addEventListener('loadeddata', function () { if (!io) play(v); });
      if (io) io.observe(v); else play(v);
    });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    Array.prototype.slice.call(document.querySelectorAll('video[data-wmg-autoplay]')).forEach(function (v) {
      if (!io) play(v);
    });
  });

  WMG.media = { refresh: bind, play: play };
  bind(document);
})();
